<template>
    <div class="modalbox">
         <!-- Modal Component para Errores/Advertencias -->
        <b-modal :visible="modalVisible" @hide="$store.commit('setModalVisible', false)" ref="ModalRefPayments" id="modal2" title="Advertencia">
            <b-list-group>
                <p class="my-4">{{this.$store.state.modalMsg}}</p>
            </b-list-group>
        </b-modal>
    </div>   
</template>

<script>


export default {
    name: 'ModalBox',
    data() {
        return {
             ModalMsg: ""
        }
    },
    computed:{
        modalVisible() {
                return this.$store.state.activeModal;  
        }
    },     
    methods:{           
        
    }
}
</script>

<style scoped>

</style>